// 简单的错误处理工具
class SimpleErrorHandler {
  private errors: any[] = [];

  // 记录错误
  logError(error: any, context?: string) {
    const errorInfo = {
      timestamp: new Date().toISOString(),
      message: error?.message || String(error),
      stack: error?.stack,
      context: context || 'Unknown',
      url: window.location.href
    };

    this.errors.unshift(errorInfo);
    
    // 保持最多50个错误
    if (this.errors.length > 50) {
      this.errors = this.errors.slice(0, 50);
    }

    console.error('🚨 错误记录:', errorInfo);
    
    // 保存到localStorage
    try {
      localStorage.setItem('simpleErrors', JSON.stringify(this.errors));
    } catch (e) {
      console.error('保存错误失败:', e);
    }
  }

  // 获取错误
  getErrors() {
    return [...this.errors];
  }

  // 清空错误
  clearErrors() {
    this.errors = [];
    localStorage.removeItem('simpleErrors');
  }

  // 从localStorage加载
  loadErrors() {
    try {
      const stored = localStorage.getItem('simpleErrors');
      if (stored) {
        this.errors = JSON.parse(stored);
      }
    } catch (e) {
      console.error('加载错误失败:', e);
    }
  }

  // 打印错误摘要
  printSummary() {
    console.group('📊 错误摘要');
    console.log(`总错误数: ${this.errors.length}`);
    this.errors.slice(0, 5).forEach((error, index) => {
      console.log(`${index + 1}. [${error.timestamp}] ${error.message}`);
    });
    console.groupEnd();
  }
}

// 创建全局实例
const simpleErrorHandler = new SimpleErrorHandler();
simpleErrorHandler.loadErrors();

// 添加到全局对象
(window as any).simpleErrorHandler = simpleErrorHandler;

export default simpleErrorHandler;














